var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInpsection01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19187",
    "data-name": "\\uADF8\\uB8F9 19187",
    transform: "translate(-94 -1419.014)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1262",
    "data-name": "\\uD0C0\\uC6D0 1262",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(94 1419.014)",
    fill: "#ff383b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10268",
    "data-name": "\\uD328\\uC2A4 10268",
    d: "M8.554,3.737H6.145L4.342.5,2.435,3.737H.129L3.182-1.1.277-5.758h2.37L4.342-2.672,6.081-5.758H8.374L5.469-1.178Z",
    transform: "translate(99.552 1429.905)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInpsection01);
export default __webpack_public_path__ + "static/media/inpsection_01.4c6f26841f0097dd9f59710c239bea77.svg";
export { ForwardRef as ReactComponent };